module.exports = __webpack_public_path__ + "media/images/talent/mv-06-ded1b4d29828d8923acb298982766d6e.png";